import {IssueClosedIcon, IssueOpenedIcon} from '@primer/octicons-react'

import {STATUS_VISUALS} from './issue-status-visuals'
import styles from './IssueStatusIcon.module.css'

export type IssueStatusIconStatus = {
  name: string
  category: {state: 'OPEN' | 'CLOSED'}
}

export type IssueStatusVisual = (typeof STATUS_VISUALS)[string]

export type IssueStatusColor = IssueStatusVisual['color']

const ICON_CLASSES: Record<IssueStatusColor, string> = {
  open: styles.open,
  done: styles.done,
  muted: styles.muted,
}

export function issueStatusVisual(status: IssueStatusIconStatus): IssueStatusVisual {
  return (
    STATUS_VISUALS[status.name] ??
    (status.category.state === 'OPEN' ? {icon: IssueOpenedIcon, color: 'open'} : {icon: IssueClosedIcon, color: 'done'})
  )
}

export function IssueStatusIcon({
  status,
  'aria-label': ariaLabel,
}: {
  status: IssueStatusIconStatus
  'aria-label'?: string
}) {
  const {icon: StatusIcon, color} = issueStatusVisual(status)
  return <StatusIcon className={ICON_CLASSES[color]} aria-label={ariaLabel} />
}
